export enum Forms {
  ACTIVATE = 'Activate',
  SIGN_IN = 'Sign in',
  SIGN_UP = 'Sign up',
  SIGNED_IN = 'Signed in',
  FORGOT_PASSWORD = 'Forgot password',
  CHANGE_PASSWORD = 'Change password',
  RESET_PASSWORD = 'Reset password',
  SERVICES = 'Services',
  PROFILE = 'Profile'
}
